import classNames from 'classnames';

import { getImageAtSize } from '../../lib/utils';

import { useThemeClassName } from '../../contexts/ThemeContext';

import styles from '../../../styles/splashes/box-splash.module.scss';

interface BoxSplashProps {
    image?: Image | null;
    tagline?: string;
    className?: string;
}

function BoxSplash({ image = null, tagline = null, className = null }: BoxSplashProps) {
    const themeClassName = useThemeClassName(styles);
    const { url: imageUrl = null } = getImageAtSize(image, 'large') || {};
    return (
        <div className={classNames([styles.container, themeClassName, className, 'box-splash'])}>
            <div className={classNames([styles.splash, 'splash'])}>
                {imageUrl !== null ? (
                    <img
                        src={imageUrl}
                        className={classNames([styles.image, 'image'])}
                        alt="Splash"
                    />
                ) : null}
            </div>
            {tagline !== null ? (
                <div
                    className={classNames([styles.tagline, 'tagline'])}
                    dangerouslySetInnerHTML={{ __html: tagline }}
                />
            ) : null}
        </div>
    );
}

export default BoxSplash;
